import ReactDOM from 'react-dom/client';
import App from './jsx/app.react';
import '../css/base.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
